export default __webpack_public_path__ + "static/media/AdobeStock_300015712.0c2a555b.jpg";